import designTokens from "./designTokens";

const button = designTokens.semantic.button.authPrimaryAction;

/**
 * View-R Design System PrimaryButton used by the Email-first auth flow.
 * Figma: Default 159:22465 · Hovered 159:22470 · Selected 159:22476.
 */
export const authPrimaryButtonSx = {
  minWidth: button.minWidth,
  height: button.height,
  px: button.paddingX,
  py: button.paddingY,
  borderRadius: button.radius,
  textTransform: "none",
  boxShadow: "none",
  color: button.text,
  backgroundColor: button.background.dark,
  backgroundImage: "none",
  fontFamily: designTokens.typography.fontFamily.roboto,
  fontSize: button.fontSize,
  fontWeight: button.fontWeight,
  lineHeight: button.lineHeight,
  "&:hover": {
    backgroundColor: button.background.dark,
    backgroundImage: `linear-gradient(${button.hoverOverlay}, ${button.hoverOverlay})`,
    boxShadow: "none",
  },
  "&:active": {
    backgroundColor: button.background.dark,
    backgroundImage: `linear-gradient(${button.selectedOverlay}, ${button.selectedOverlay})`,
    boxShadow: "none",
    transform: "none",
  },
  "&.Mui-disabled": {
    color: designTokens.fill.text.grey80.dark,
    backgroundColor: designTokens.fill.shape.grey40.dark,
    backgroundImage: "none",
  },
} as const;
